<template>
  <ProductForm :class="!loading && 'disable-ske'"
    :value="initialData"
    :isShowing="isShowing"
    
    @save="save"
  />
</template>

<script>

import ProductForm from "./ProductFields/Form.vue"

export default {
  components: {
    ProductForm,
  },
  props: {
    isShowing: Boolean,
    baseData: Object,
    websiteUid: String,
    productId: String,
  },
  data() {
    return {
      initialData: {},
      loading: true,
    }
  },
  created() {
    this.loadOverwritenProduct()
  },
  methods: {
    async save(form) {
      this.$handlePromise(async () => {
        await this.axios.put(`/api/websites/${this.websiteUid}/products/${this.productId}`, form)
        await this.loadOverwritenProduct()
        this.$success("Product succesvol overschreven!")
      })
    },
    async loadOverwritenProduct() {
      this.loading = true

      let overwritten = {}
      try {
        overwritten = (await this.axios.get(`/api/websites/${this.websiteUid}/products/${this.productId}`)).data
      } catch (err) {}

      const data = {...this.baseData}
      Object.keys(data).forEach(key => {
        if (overwritten[key]) data[key] = overwritten[key]
      })
      data.price = !overwritten.price ? this.baseData.recommended_retail_price : overwritten.price
      
      this.initialData = data
      this.loading = false
    },
  },
  watch: {
    websiteUid() {
      this.loadOverwritenProduct()
    },
  },
}

</script>

